'use strict';
checkExpire.$inject = [];
function checkExpire() {
  return function(reminder) {
    var dueAt = new Date(reminder.dueAt),
        currentDate = new Date();
    if (dueAt.getTime() < currentDate.getTime()) {
      return true;
    }
    return false;
  };
}

angular.module('dokiv')
  .filter('reminderCheckExpire', checkExpire);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/reminderFilterExpired.js
// module id = 267
// module chunks = 0